import React from "react";

import {
    Grid,
    Paper,
    Typography,
    Button,
    IconButton,
    Tooltip,
    Hidden
} from "@material-ui/core";

import {
    People,
    AccountBalanceWallet,
    ShoppingBasket,
    Settings,
    Group,
    PlaylistAddCheck,
    Edit,
    Home,
    HelpOutline,
    ShowChart,
    Refresh,
    Menu,
    Check,
    ShoppingCart
} from "@material-ui/icons";

import "./mainstyle.css";
import { sto } from "../../Context/InshData";
import SwipeableNew, { dateExpire } from "./SwipeableNew";
import { local } from "../../Context/Local";
import { useHistory } from 'react-router-dom';
import i18next from "i18next";
import { useTranslation } from 'react-i18next';


const mainSystems = [
    {
        no: 0,
        id: "sales",
        title: "sales-title",
        icon: ShoppingCart,
        color: "#008000",
        background: "#edf8ed",
        description: "إدارة فواتير المبيعات والعملاء"
    },
    {
        no: 1,
        id: "purchases",
        title: "purchases-title",
        icon: ShoppingBasket,
        color: "#008b8b",
        background: "#e9f8f7",
        description: "إدارة فواتير المشتريات والموردين"
    },
    {
        no: 2,
        id: "warehouse",
        title: "stores-title",
        icon: AccountBalanceWallet,
        color: "#4b409e",
        background: "#f0effb",
        description: "إدارة الأصناف والمخزون"
    },
    {
        no: 3,
        id: "customers",
        title: "customers-and-suppliers-title",
        icon: People,
        color: "#85008f",
        background: "#faeffb",
        description: "إدارة العملاء والموردين"
    },
    {
        no: 4,
        id: "accounts",
        title: "accounts-title",
        icon: Edit,
        color: "#888888",
        background: "#f3f3f3",
        description: "إدارة الحسابات والقيود المالية"
    },
    {
        no: 5,
        id: "basicData",
        title: "basic-information-title",
        icon: PlaylistAddCheck,
        color: "#d65e62",
        background: "#fff0f0",
        description: "إدارة البيانات الأساسية للنظام"
    },
    {
        no: 6,
        id: "users",
        title: "users-and-permissions-title",
        icon: Group,
        color: "#4c84bd",
        background: "#edf5fd",
        description: "إدارة المستخدمين وتحديد الصلاحيات"
    },
    {
        no: 7,
        id: "settings",
        title:"system-settings-title",
        icon: Settings,
        color: "#59c2a1",
        background: "#eaf9f3",
        description: "إعدادات النظام والبيانات العامة"
    }
];


export default function MainNew({
    found,
}) {
    let his = useHistory();
    const { t } = useTranslation();
    const { t: transForm } = useTranslation(["forms"]);

    const handleSystemClick = (system) => {
        // if (onSystemClick) {
        //   onSystemClick(system);
        // }

        his.push({
            pathname: '/depts',
            state: { local: local[system.no], },
        })
    };


    return (
        <div className="orax-dashboard" dir="rtl">

            {/* =========================
          الشريط العلوي
      ========================= */}

            <header className="orax-topbar">

                <div className="orax-topbar-info">
                    <Hidden smDown={["sm"]}>
                        <div className="orax-info-item">
                            <span>اسم المؤسسة</span>
                            <strong>{found?.nameA}</strong>
                        </div>
                    </Hidden>

                    <span className="orax-info-divider" />
                    {sto?.db_name != null && sto?.db_name !== "" &&
                        <div className="orax-info-item">
                            <span>السنة المالية</span>
                            <strong>{sto?.db_label}</strong>
                        </div>
                    }
                    <span className="orax-info-divider" />

                    <div className="orax-info-item">
                        <span>{transForm("branch")}</span>
                        <strong>{sto?.usernames}</strong>
                    </div>

                    <span className="orax-info-divider" />

                    <div className="orax-info-item">
                        <span>{transForm("user")}</span>
                        <strong>{sto?.usernames}</strong>
                    </div>

                </div>

                <div className="orax-topbar-actions">

                    <Tooltip title="الرئيسية">
                        <IconButton
                            className="orax-top-icon"
                        //   onClick={onHomeClick}
                        >
                            <Home />
                        </IconButton>
                    </Tooltip>

                </div>

            </header>


            {/* =========================
          مساحة المحتوى الرئيسية
      ========================= */}

            <main className="orax-main-content">

                <Paper
                    elevation={0}
                    className="orax-systems-panel"
                >

                    {/* عنوان اللوحة */}

                    <div className="orax-panel-header">

                        <div className="orax-panel-title">

                            <div className="orax-title-icon">
                                <Menu />
                            </div>

                            <div>
                                <Typography
                                    component="h1"
                                    className="orax-title-text"
                                >
                                    الأنظمة الرئيسية
                                </Typography>

                                <Typography
                                    component="p"
                                    className="orax-title-subtitle"
                                >
                                    جميع أنظمة أوراكس سوفت في مكان واحد
                                </Typography>
                            </div>

                        </div>

                        <div className="orax-panel-counter">
                            <span className="orax-counter-dot" />
                            {mainSystems.length} أنظمة
                        </div>

                    </div>


                    {/* بطاقات الأنظمة */}

                    <Grid
                        container
                        spacing={2}
                        className="orax-systems-grid"
                    >

                        {mainSystems.map((system, index) => {

                            const SystemIcon = system.icon;

                            return (

                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={3}
                                    key={system.id}
                                >

                                    <Paper
                                        elevation={0}
                                        className="orax-system-card"
                                        style={{
                                            "--system-color": system.color,
                                            "--system-background": system.background
                                        }}
                                        onClick={() =>
                                            handleSystemClick(system)
                                        }
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(event) => {
                                            if (
                                                event.key === "Enter" ||
                                                event.key === " "
                                            ) {
                                                event.preventDefault();
                                                handleSystemClick(system);
                                            }
                                        }}
                                    >

                                        {/* لون زخرفي في البطاقة */}

                                        <div className="orax-card-decoration" />

                                        {/* أيقونة النظام */}

                                        <div className="orax-card-icon">

                                            <SystemIcon />

                                        </div>


                                        {/* معلومات النظام */}

                                        <div className="orax-card-content">

                                            <Typography
                                                component="h2"
                                                className="orax-card-title"
                                            >
                                                {t(system.title)}
                                            </Typography>

                                            <Typography
                                                component="p"
                                                className="orax-card-description"
                                            >
                                                {system.description}
                                            </Typography>

                                        </div>


                                        {/* سهم البطاقة */}

                                        <div className="orax-card-arrow">
                                            ‹
                                        </div>

                                    </Paper>

                                </Grid>

                            );

                        })}

                    </Grid>

                </Paper>

            </main>


            {/* =========================
          الشريط السفلي
      ========================= */}
            <div className="orax-bottom-actions" >
                <SwipeableNew found={found} />
            </div>

        </div>
    );
}